import H4 from "../../Typography/Headings/H4/styled";
import styled from "styled-components";

const ModalHeader = styled(H4 as any)`
    padding-bottom: 1rem;
`;

export default ModalHeader;
